// client/src/components/PdfThumbnail.jsx
import React, { useEffect, useState } from 'react';
import { loadPdfDocument, renderPdfPage } from '../utils/pdfjs';

export default function PdfThumbnail({ fileUrl, label = 'PDF', width = 120, className = '' }) {
    const [thumbnailUrl, setThumbnailUrl] = useState('');
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            if (!fileUrl) {
                setThumbnailUrl('');
                return;
            }
            try {
                setHasError(false);
                const pdfDoc = await loadPdfDocument(fileUrl);
                const firstPage = await pdfDoc.getPage(1);
                const viewport = firstPage.getViewport({ scale: 1 });
                const targetWidth = Number(width) || 120;
                const scale = (targetWidth / viewport.width) * (window.devicePixelRatio || 1);
                const { canvas } = await renderPdfPage(pdfDoc, 0, scale);
                if (!isMounted) return;
                setThumbnailUrl(canvas.toDataURL('image/png'));
            } catch (err) {
                if (!isMounted) return;
                setHasError(true);
                setThumbnailUrl('');
            }
        };
        load();
        return () => {
            isMounted = false;
        };
    }, [fileUrl, width]);

    return (
        <div
            className={`pdf-thumbnail${className ? ` ${className}` : ''}`}
            style={{ width: `${width}px` }}
            aria-label={label}
        >
            {thumbnailUrl ? (
                <img src={thumbnailUrl} alt={label} className="pdf-thumbnail__image" />
            ) : (
                <div className="pdf-thumbnail__placeholder">{hasError ? 'PDF' : '...'}</div>
            )}
        </div>
    );
}
